import {
	Box,
	Chip,
	FormControl,
	Input,
	InputLabel,
	MenuItem,
	Select,
	type Theme,
	useTheme,
} from "@mui/material";
// @flow
import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import { getAuthTypes } from "../../repositories/UsersRepository";

export const searchAuthTypes = () => {
	return useQuery<AuthType[], Error>({
		queryKey: ["authTypes"],
		queryFn: ({ signal }) => getAuthTypes(signal),
	});
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

type Props = {
	value: number | null;
	onChange: (val: number) => void;
	disabled?: boolean;
};
export const AuthTypeSelector = ({ value, onChange, disabled }: Props) => {
	const theme = useTheme();

	const [error, setError] = useState("");

	const {
		data: authTypes,
		isLoading,
		isSuccess,
		isError,
		error: e,
	} = searchAuthTypes();

	const getStyles = (
		AuthTypeId: number,
		authTypes: AuthType[],
		theme: Theme,
	) => {
		return {
			fontWeight: !!authTypes.find((p) => p.AuthTypeId === AuthTypeId)
				? theme.typography.fontWeightRegular
				: theme.typography.fontWeightMedium,
		};
	};

	function getAuthNameById(AuthTypeId: number) {
		return authTypes?.find((p) => p.AuthTypeId === AuthTypeId)?.Name || "";
	}

	const selectedAuthTypeName = useMemo(() => {
		return (
			authTypes?.find((authType) => authType.AuthTypeId === value)?.Name ||
			"Empty"
		);
	}, [authTypes, value]);

	useEffect(() => {
		if (e && isError) {
			setError(e.message);
		}
	}, [e, isError]);

	return (
		<Box
			sx={{
				"& .MuiSelect-select": {
					minHeight: "40px",
				},
			}}
		>
			{!isLoading && authTypes?.length ? (
				<FormControl
					sx={{
						width: "100%",
					}}
					disabled={disabled}
				>
					<InputLabel id="demo-mutiple-chip-label">Auth type</InputLabel>
					<Select
						autoWidth={true}
						labelId="demo-mutiple-chip-label"
						id="demo-mutiple-chip"
						value={value}
						style={{ padding: 0 }}
						onChange={onChange as any}
						input={<Input />}
						renderValue={(selected) => (
							<Box
								sx={{
									display: "flex",
									flexWrap: "wrap",
								}}
							>
								<Chip
									key={`selected-authType-${selected}`}
									label={selectedAuthTypeName}
									size="medium"
									sx={{ mx: 0.5 }}
								/>
							</Box>
						)}
						MenuProps={MenuProps}
					>
						{authTypes.map((authType) => (
							<MenuItem
								key={`auth-${authType.AuthTypeId}`}
								value={authType.AuthTypeId}
								style={getStyles(authType.AuthTypeId, authTypes, theme)}
							>
								{authType.Name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			) : (
				<></>
			)}
			<ErrorModal error={error} onHide={() => setError("")} />
		</Box>
	);
};
